import Grid from '@mui/material/Grid'
import Image from 'next/image'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'
import { Accordion } from '@/components/Inputs'

interface Card {
    title?: string
    subtitle?: string
}

interface ImageData {
    src?: string
    alt?: string
}

interface Content {
    title?: string
    cards?: Card[]
    image?: ImageData
}

interface S1_L3_3Props {
    content?: Content
    blockName?:string
}

const Index = (props: S1_L3_3Props) => {
    const { content } = props
    const { title, cards = [], image = {} } = content || {}
    const heroImage = getImageData(image)
    return (
        <RegularSection aria-label='S1_L3_3' >
            <Grid
                container
                spacing={4}
                sx={{ width: '100%' }}
            >
                <Grid size={12}>
                    <ColorTitle
                        title={title}
                        colorFrom={0}
                        textAlign='start'
                    />
                </Grid>

                <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                >
                    {cards.map((card, idx) => (
                        <Accordion
                            key={'detailed-accordion' + idx}
                            title={card?.title}
                            subtitle={card?.subtitle}
                            expanded={true}
                        />
                    ))}
                </Grid>

                <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, overflow: 'hidden' }}
                >
                    <Image
                        src={heroImage.src || '/img/img-160400.jpg'}
                        alt={heroImage.alt || 'man cutting concrete'}
                        width={800}
                        height={600}
                        style={{ maxHeight: '600px', objectFit: 'cover', width: '100%', height: 'auto' }}
                    />
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
